import { useIsMobile } from 'hooks/useIsMobile'
import { Article, ArticleDisplayType, Category } from 'interfaces/types'

import { SingleNormalLayout } from '../singleNormalLayout'

type Props = {
  categories?: Category[]
  layout?: ArticleDisplayType
  adUnitPath?: string
  articles: Article[]
  dataTrackingCommon: any
}

export const NormalLayout = ({
  layout,
  articles,
  categories = [],
  adUnitPath,
  dataTrackingCommon,
}: Props) => {
  const isMobile = useIsMobile()
  return (
    <SingleNormalLayout
      categories={categories}
      articles={articles}
      layout={isMobile ? 'list-contain-ads' : layout}
      adUnitPath={adUnitPath}
      dataTrackingCommon={dataTrackingCommon}
    />
  )
}
